import BaseModel from './BaseModel';

class Cluster extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data);
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.branch = data.branch;
    if(data.sap_code?.constructor === Object){
      this.sap_code = data.sap_code?.code || "";
      this.sap_code_id = data.sap_code?.id || "";
    } else {
      this.sap_code = data.sap_code || "";
      this.sap_code_id = data.sap_code_id || "";
    }
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      cluster: {
        name: this.name.toUpperCase(),
        branch_id: this.branch.id,
        sap_code_attributes: {
          id: this.sap_code_id || "",
          code: this.sap_code
        },
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if (this[field].trim() === "") {
          this.errors.name = "This field is required and cannot be empty.";
        }
        else if (this[field].search(/^[a-zA-Z\s'-]+$/) === -1) {
          this.errors.name = "Use letters only";
        } else {
          delete this.errors.name;
        }
      },
      branch: () => {
        if (!this[field] || this[field].length === 0) {
          this.errors.branch = "Please select branch.";
        } else {
          delete this.errors.branch;
        }
      },
      sap_code: () => {
        if (!this[field] || this[field] === "") {
          this.errors.sap_code = "This field is required and cannot be empty.";
        } else if (this[field].search(/^\d{4}$/) === -1) {
          this.errors.sap_code = "Please enter valid cluster code format. (for ex.: 1234)";
        } else {
          delete this.errors.sap_code;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default Cluster;